<template lang="html">
  <d-tabs class="w-100 mb-4 px-1" ref="tabs">
    <d-tab :title="address.label" class="p-3" v-for="(address, index) in model" :key="index">
      <d-form-row>
        <!-- Label -->
        <d-col md="2" class="form-group">
          <label for="feInputLabel">Etiqueta</label>
          <d-form-input
            type="text"
            id="feInputLabel"
            placeholder="Identificação do endereço"
            v-model="address.label"
            :disabled="address.label == 'Endereço Principal'"
            @change="capitalizeAddressInput('label', index)"
          />
        </d-col>

         <!-- CEP -->
        <d-col md="2"  class="form-group">
          <label for="inputCEP">CEP</label>
          <masked-input
            type="text"
            class="text-left form-control"
            id="inputCEP"
            placeholder="00.000-000"
            :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
            :guide="false"
            v-model="address.zipcode"
            @blur="consultaCEP(address.zipcode, index)"
          ></masked-input>
        </d-col>
      </d-form-row>

      <d-form-row>
        <!-- Logradouro -->
        <d-col md="10" class="form-group">
          <label for="feInputEndereco">Logradouro</label>
          <d-form-input
            type="text"
            id="feInputEndereco"
            placeholder="Rua,Av,Travessa"
            v-model="address.street"
            @change="capitalizeAddressInput('street', index)"
          />
        </d-col>

        <!-- Numero -->
        <d-col md="2" class="form-group">
          <label for="feInputNumero">Número</label>
          <d-form-input type="text" id="feInputNumero" placeholder="Número" v-model="address.number"/>
        </d-col>

      </d-form-row>

      <d-form-row>

        <!-- Complemento -->
        <d-col md="3" class="form-group">
          <label for="feInputComplemento">Complemento</label>
          <d-form-input
            type="text"
            id="feInputComplemento"
            v-model="address.address2"
            placeholder="apartamento,bloco,etc..."
            @change="capitalizeAddressInput('address2', index)"
          />
        </d-col>

        <!-- Bairro -->
        <d-col md="3" class="form-group">
          <label for="feInputBairro">Bairro</label>
          <d-form-input
            type="text"
            id="feInputBairro"
            v-model="address.district"
            @change="capitalizeAddressInput('district', index)"
          />
        </d-col>

        <!-- Cidade -->
        <d-col md="4" class="form-group">
          <label for="feInputCidade">Cidade</label>
          <d-form-input
            type="text"
            id="feInputCidade"
            v-model="address.city"
            @change="capitalizeAddressInput('city', index)"
          />
        </d-col>

        <!-- Estado -->
        <d-col md="2" class="form-group">
          <label for="feInputEstado">Estado</label>
          <select-state :model.sync="address.state"/>
        </d-col>

      </d-form-row>

      <d-form-row class="justify-content-end">
        <d-col class="text-right">
          <d-button type="button" class="btn-success" @click="addAddress()">Novo endereço</d-button>
          <d-button v-if="customer.id" type="button" class="btn-primary ml-3" @click="saveAddress(index)">Salvar endereço</d-button>
          <d-button type="button" class="btn-danger ml-3" @click="removeAddress(index)" v-if="index>0">Remover endereço</d-button>
        </d-col>
      </d-form-row>
    </d-tab>
  </d-tabs>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import CustomerService from '_services/rest/modules/customer';
import { capitalize } from '_utils/string';
import { ADDRESS } from './CustomerModel';

export default {
  name: 'addresses',
  components: {
    Loader,
    MaskedInput,
    SelectState,
  },
  props: {
    customer: {
      type: Object,
      default: null,
      required: true,
    },
    addresses: {
      type: Array,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      model: this.customer.addresses,
      loading: false,
    };
  },
  computed: {
  },
  watch: {
    customer(newValue) {
      this.model = newValue.addresses;
      this.updateTabs();
    },
    model: {
      handler(val) {
        Events.$emit('update:addresses', val);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getCustomerAddress',
    ]),
    addAddress() {
      const address = { ...ADDRESS, ...{ label: 'Novo Endereço' } };
      this.model.push(address);
      this.updateTabs();
    },
    capitalizeAddressInput(field, index) {
      this.model[index][field] = capitalize(this.model[index][field]);
    },
    consultaCEP(cep, index) {
      const cepClean = cep.replace(/\D/g, '');
      const validacep = /^[0-9]{8}$/;
      if (cepClean !== '' && validacep.test(cepClean)) {
        CustomerService.getCep(cepClean)
          .then(response => {
            this.model[index].city = response.localidade;
            this.model[index].state = response.uf;
            this.model[index].district = response.bairro;
            this.model[index].street = response.logradouro;
          });
      }
    },
    removeAddress(index) {
      if (!this.model[index].id) {
        this.updateTabs();
        return this.model.splice(index, 1);
      }
      return CustomerService.removeAddress(this.customer.id, this.model[index].id)
        .then(() => {
          this.getCustomerAddress(this.model.splice(index, 1));
          this.updateTabs();
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    saveAddress(index = 0) {
      const address = this.model[index];
      CustomerService.saveAddress(this.customer.id, address)
        .then(response => {
          this.model[index].id = response.id;
          this.activeAlert({ message: 'Endereço salvo com sucesso!', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    updateTabs() {
      setTimeout(() => {
        this.$refs.tabs.updateTabs();
      }, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
